export default __webpack_public_path__ + "static/bg-tech-nation-5d4e4f6129e3dd0827ef0b99557aa245.webp";